import React from "react";

const STEPS = [
  { key: "uploaded", label: "Upload" },
  { key: "parsing", label: "Parsing" },
  { key: "plan_pending", label: "Plan", manual: true },
  { key: "plan_approved", label: "Plan validé" },
  { key: "chunking", label: "Chunking" },
  { key: "chunked", label: "Chunks prêts", manual: true },
  { key: "embedding", label: "Embedding" },
  { key: "embedded", label: "Vecteurs prêts", manual: true },
  { key: "graphing", label: "Graphe" },
  { key: "done", label: "Terminé" },
];

export default function PipelineStepper({ status }) {
  const currentIdx = STEPS.findIndex((s) => s.key === status);
  return (
    <ol className="pipeline-stepper">
      {STEPS.map((step, i) => (
        <li
          key={step.key}
          className={
            "pipeline-stepper__step" +
            (i < currentIdx ? " pipeline-stepper__step--done" : "") +
            (i === currentIdx ? " pipeline-stepper__step--current" : "") +
            (i === currentIdx && step.manual ? " pipeline-stepper__step--waiting" : "") +
            (status === "error" && i === currentIdx ? " pipeline-stepper__step--error" : "")
          }
        >
          {step.label}
        </li>
      ))}
    </ol>
  );
}
